export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9205.33fb536f.jpg";